export const isDev = process.env.NODE_ENV === 'development'
export const isTest = process.env.NODE_ENV === 'test'

export interface onCloseHandler {
  (event?: any): void
}
